// extracted by mini-css-extract-plugin
export var avatarContainer = "_68-1";
export var largeAvatarContainer = "_68-2";
export var smallAvatarContainer = "_68-0";